import React from 'react';
import 'styles/common.module.scss';
import css from 'styles/product/zhdj.module.scss';
import HeadTag from 'cps/headTag';
import Layout from 'cps/layout';
import ic_next1 from 'img/ic_next1.svg';
import img_scene1 from 'img/img_scene1.png';
import img_scene2 from 'img/img_scene2.png';
import img_scene3 from 'img/img_scene3.png';
import arrow_tip from 'img/arrow_tip.png';
import case_img1 from 'img/case_img1.png';
import case_img1_logo from 'img/case_img1_logo.png';
import case_img2 from 'img/case_img2.png';
import case_img2_logo from 'img/case_img2_logo.png';
import case_img3 from 'img/case_img3.png';
import case_img3_logo from 'img/case_img3_logo.png';
class Zhdj extends React.Component{

  componentDidMount () {
   this.movePlay();
  }

  moveIndex(list,num) {
    for(let i=0;i<list.length;i++){
      if(list[i].className==='active'){//清除li的透明度样式
        list[i].className='';
      }
    }
    list[num].className='active';
  }

  moveImg(list,num) {
    for(let i=0;i<list.length;i++){
      if(list[i].className==='opaOn'){
        list[i].className='';
      }
    }
    list[num].className='opaOn';
  }

  movePlay = () =>{
    let list=document.getElementById('list').getElementsByTagName('li');
    let imgList=document.getElementById('imgList').getElementsByTagName('li');
    let index=0;
    let timer;
    let _this = this;

    const nextMove =()=>{
      index+=1;
      if(index>=3){
        index=0
      }
      this.moveImg(imgList,index);
      this.moveIndex(list,index);
    };

    const play =()=>{
      timer=setInterval(function(){
        nextMove();
      },2800);
    };

    play();  // 自动播放

    for(let i=0;i<list.length;i++){
      list[i].index=i;
      list[i].onmouseover = function () {
        let clickIndex = parseInt(this.index);
        index=clickIndex;
        _this.moveIndex(list,index);  // 切换文字
        _this.moveImg(imgList,index); // 切换图片
        clearInterval(timer);
      };

      list[i].onmouseout= function () {//移开后继续轮播
        play();
      }
    }

  }

  render() {
    return (
      <Layout>
      <HeadTag title="杭博科思科技有限公司-智慧党建"/>
      <a target="_blank" href="https://www.51zhdj.cn" className={css.banner} rel="noopener noreferrer" />
      <div className={css.box}>
        <div className="quality">
          <h2>新时代党建 就用微加智慧党建云平台</h2>
          <div className="qualityContent">
            <ul id="list" className="tabList">
              <li className="active">
                <div className="redio">
                  <span></span>
                  <img src={ic_next1} alt="" />
                </div>
                <div className="box">
                  <h3>高效落实三会一课</h3>
                  <p>会议通知 → 会议签到 → 会议纪要，一个应用轻松完成会议学习</p>
                </div>
              </li>
              <li>
                <div className="redio">
                  <span></span>
                  <img src={ic_next1} alt="" />
                </div>
                <div className="box">
                  <h3>随时进行学习考试</h3>
                  <p>政策法规、专题教育等应用助力碎片化时间学习，在线考试检验党员学习成果</p>
                </div>
              </li>
              <li>
                <div className="redio">
                  <span></span>
                  <img src={ic_next1} alt="" />
                </div>
                <div className="box">
                  <h3>丰富党内组织生活</h3>
                  <p>使用入党纪念、党建相册、活动报名等应用打造党内文化建设</p>
                </div>
              </li>
            </ul>
            <ul id="imgList" className="rightImg">
              <li className="opaOn"><img src={img_scene1} alt="三会一课"/></li>
              <li><img src={img_scene2} alt="在线考试"/></li>
              <li><img src={img_scene3} alt="入党纪念"/></li>
            </ul>
          </div>
        </div>
        <a className="btn-try-now" href="https://www.51zhdj.cn/" target="_blank" rel="noopener noreferrer">
          了解更多详情&nbsp;&nbsp;<img src={arrow_tip} alt=""/>
        </a>
        <div className="case">
          <h2>用户心声</h2>
          <ul className="list">
            <li>
              <div className="box"><img className="img" src={case_img1} alt="神华集团"/></div>
              <p>微加智慧党建云平台可以直接在微信中使用，很方便，这也是我们选择它的原因之一。投票调研、在线考试、活动报名等功能都很实用。</p>
              <div className="case-logo"><span className="line line-left"></span><img alt="神华集团" src={case_img1_logo} /></div>
            </li>
            <li>
              <div className="box"><img className="img"  src={case_img2} alt="徐工集团"/></div>
              <p>微加智慧党建云平台的20多个功能符合党建工作信息化建设的需求。与其他党建应用相比较，界面更美观，操作更方便。</p>
              <div className="case-logo"><span className="line line-left"></span><img alt="徐工集团" src={case_img2_logo} /></div>
            </li>
            <li>
              <div className="box"><img className="img" src={case_img3} alt="浙江大学"/></div>
              <p>学生们觉得微加智慧党建云平台的水印技术比较酷，提高了学生党员在网络环境的言行规范。</p>
              <div className="case-logo"><span className="line line-left"></span><img alt="浙江大学" src={case_img3_logo} /></div>
            </li>
          </ul>
          <a href="https://www.51zhdj.cn/case/caseList.html" target="_blank" className="lookmore" rel="noopener noreferrer">查看更多案例 &gt;</a>
        </div>
      </div>
      </Layout>
    )
  }
}

export default Zhdj;
